import { combineReducers } from 'redux';

import apiError from './apiError';
import data from './data';
import filters from './filters';
import isFetching from './isFetching';

/**
 * @typedef {{
 *  apiError: string,
 *  isFetching: boolean,
 *  filters: Object,
 *  data: import('./data').StatisticsSelfServiceTopContributorDataReducer
 * }} StatisticsSelfServiceTopContributorReducer
 */

export default combineReducers({
  data,
  filters,
  apiError,
  isFetching,
});
